import { ConsultationResponseAnswer } from '../../../../types';

/**
 * The function `sortAnswers` sorts an array of `ConsultationResponseAnswer` objects based on their
 * `questionNumber` and `id` properties.
 * @param {ConsultationResponseAnswer} answerA - The parameter `answerA` is of type
 * `ConsultationResponseAnswer`. It represents one answer to a consultation response.
 * @param {ConsultationResponseAnswer} answerB - The `answerB` parameter is of type
 * `ConsultationResponseAnswer`. It represents one of the answers given in a consultation response.
 * @returns The function `sortAnswers` returns a number.
 */
export const sortAnswers = (
  answerA: ConsultationResponseAnswer,
  answerB: ConsultationResponseAnswer
): number => {
  if (answerA.questionNumber > answerB.questionNumber) return 1;
  if (answerA.questionNumber < answerB.questionNumber) return -1;
  return (answerA?.id ?? 0) > (answerB?.id ?? 0) ? 1 : -1;
};
